import { useTranslation } from "react-i18next";

import { RiFacebookCircleFill, RiLinkedinBoxFill } from "react-icons/ri";

import ecosystem_1 from "../assets/images/ecosystem_1.jpg";
import ecosystem_2 from "../assets/images/ecosystem_2.jpg";
import ecosystem_3 from "../assets/images/ecosystem_3.jpg";
import ecosystem_4 from "../assets/images/ecosystem_4.jpg";

import products_1 from "../assets/images/products_1.jpg";
import products_2 from "../assets/images/products_2.jpg";
import products_3 from "../assets/images/products_3.jpg";

import values_1 from "../assets/icons/values_1.png";
import values_2 from "../assets/icons/values_2.png";
import values_3 from "../assets/icons/values_3.png";

import empty_profile from "../assets/team/empty_profile.png";
import marcus_tan from "../assets/team/marcus_tan.jpg";
import ooibc_s from "../assets/team/ooibc_s.jpg";
import zhangmeihui from "../assets/team/zhangmeihui.png";

import about_image from "../assets/background/about_bg.png";
import challenge_bg from "../assets/background/challenge_bg.jpg";

import solution from "../assets/images/solution.png";

import partners_nhg from "../assets/partners/nhg_logo.png";
import partners_nus from "../assets/partners/nus_logo.png";
import partners_nusdbsys from "../assets/partners/nusdbsystem_logo.png";
import partners_nuhs from "../assets/partners/NUHS.png";
import partners_sbip from "../assets/partners/sbip_logo.png";
import partners_singhealth from "../assets/partners/singhealth_logo.png";

const useContent = () => {
  const { t } = useTranslation();

  const content = {
    hero: {
      header: t("HERO_HEADER"),
      headers: [
        "remote patient monitoring",
        "enable patients and relatives to become active participants",
        "integrate care plans across organisations",
        "securely exchange patient data",
        "manage care plans with multimorbidity",
      ],
      subheaders: [
        "Acquire patients' data from their home",
        "Support a patient-centered care approach",
        "Integrate and share patients' care plans with relevant carers",
        "A unique, privacy compliant, data exchange",
        "Analyse conflicts in multi-morbidity care plans",
      ],
      content:
        "Transforming Complex Chronic Condition Management with personalised AI-Driven Digital Health Solutions",
      action: t("HERO_ACTION"),
      subaction: t("HERO_SUBACTION"),
    },

    ecosystem: {
      header: "The ChroniCare Ecosystem",
      body: "A unified, patient-centered approach integrating:",
      items: [
        {
          id: 1,
          image: ecosystem_1,
          title: "Patients & Caregivers",
          text: "Self-management tools for independent living.",
          width: "50%",
        },
        {
          id: 2,
          image: ecosystem_2,
          title: "Community-Based Clinicians",
          text: "Seamless coordination with home-based care providers.",
          width: "30%",
        },
        {
          id: 3,
          image: ecosystem_3,
          title: "Pharmacists & Social Care Workers",
          text: "Ensuring medication safety and lifestyle support.",
          width: "50%",
        },
        {
          id: 4,
          image: ecosystem_4,
          title: "Hospital-Based Specialists",
          text: "Direct access to patient data for timely interventions.",
          width: "30%",
        },
      ],
    },

    products: {
      header: "ChroniCare: AI-driven, seamless health management",
      subheader: "Cutting-Edge Technology",
      body: "",
      items: [
        {
          action: "Learn more",
          header: "",
          subheader: "Blockchain-Powered Data Security",
          image: products_1,
          body: "",
          list_items: [
            "Ensures seamless and trusted data sharing across care teams.",
            "Integrates with hospital EMR systems for real-time access.",
          ],
        },
        {
          action: "Learn more",
          header: "",
          subheader: "Advanced AI & Machine Learning",
          image: products_2,
          body: "",
          list_items: [
            "Understands the progression of complex chronic conditions for early intervention.",
            "Identifies drug-disease and drug-lifestyle-disease interactions to prevent polypharmacy and adverse drug reactions.",
          ],
        },
        {
          action: "Learn more",
          header: "",
          subheader: "LLM-Powered Clinical Knowledge",
          image: products_3,
          list_items: [
            "Continuously updates clinician notes with the latest medical research.",
            "Provides real-time personalized treatment recommendations for multimorbidity management.",
          ],
        },
      ],
    },

    solution: {
      background: "",
      body: "ChroniCare is the first explainable, personalised AI-driven, and privacy-secure digital health platform designed specifically for multimorbidity management.",
      header: "ChroniCare",
      image: solution,
      subheader: "Our Solution",
    },

    team: {
      header: "Meet the team",
      subheader: "Who we are",
      body: "",
      members: [
        {
          image: ooibc_s,
          header: "Professor Ooi Beng Chin",
          content: "founder and chief scientific and technology advisor",
          action: "",
          link: "",
        },
        {
          image: empty_profile,
          header: "Dr. Marcus Tan",
          content: "co-founder and medical advisor",
          action: "",
          link: "",
        },
        {
          image: zhangmeihui,
          header: "Dr. Zhang Mei Hui",
          content: "chief technology officer",
          action: "",
          link: "",
        },
      ],
      action: "",
    },

    publications: {
      header: "Publications",
      subheader: "",
      body: "Publications highlighting our developments and research findings will be featured here as they become available.",
      items: [
        {
          year: 2021,
          items: [
            {
              image: "",
              subHeader: "SIGMOD, 2021",
              header:
                "Blockchains vs. Distributed Databases: Dichotomy and Fusion",
              authors:
                "P. Ruan, T. T. A. Dinh, D. Loghin, M. Zhang, G. Chen, Q. Lin, B. C. Ooi",
              action: "Read Paper",
              link: "https://www.comp.nus.edu.sg/~ooibc/bcvsdb.pdf",
            },
          ],
        },
        {
          year: 2020,
          items: [
            {
              image: "",
              subHeader: "SIGMOD, 2020",
              header:
                "A Transactional Perspective on Execute-order-validate Blockchains",
              authors:
                "P. Ruan, D. Loghin, Q.-T. Ta, M. Zhang, G. Chen, B. C. Ooi.",
              action: "Read Paper",
              link: "https://dl.acm.org/doi/abs/10.1145/3318464.3389693",
            },
          ],
        },
        {
          year: 2019,
          items: [
            {
              image: "",
              subHeader: "SIGMOD, 2019",
              header: "Towards Scaling Blockchain Systems via Sharding",
              authors:
                "Hung Dang, Tien Tuan Anh Dinh, Dumitrel Loghin, Ee-Chien Chang, Qian Lin, Beng Chin Ooi.",
              action: "Read Paper",
              link: "https://dl.acm.org/doi/10.1145/3299869.3319889",
            },
            {
              image: "",
              subHeader: "VLDB, 2019",
              header:
                "Fine-Grained, Secure and Efficient Data Provenance on Blockchain Systems",
              authors:
                "Pingcheng Ruan, Gang Chen, Tien Tuan Anh Dinh, Qian Lin, Beng Chin Ooi, Meihui Zhang",
              action: "Read Paper",
              link: "https://dl.acm.org/doi/10.14778/3329772.3329775",
            },
            {
              image: "",
              subHeader: "VLDB, 2019",
              header: "Understanding the Scalability of Hyperledger Fabric",
              authors:
                "Nguyen Minh Quang, Dumitrel Loghin, Tien Tuan Anh Dinh.",
              action: "Read Paper",
              link: "https://arxiv.org/pdf/2107.09886",
            },
          ],
        },
        {
          year: 2018,
          items: [
            {
              image: "",
              subHeader:
                "IEEE Transactions on Knowledge and Data Engineering, 2018",
              header:
                "Untangling Blockchain: A Data Processing View of Blockchain Systems",
              authors:
                "T. T. A. Dinh, R. Liu, M. Zhang, G. Chen, B. C. Ooi, and J. Wang.",
              action: "Read Paper",
              link: "https://www.comp.nus.edu.sg/~ooibc/blockchainsurvey.pdf",
            },
          ],
        },
        {
          year: 2017,
          items: [
            {
              image: "",
              subHeader: "SIGMOD, 2017",
              header:
                "BLOCKBENCH: A Framework for Analyzing Private Blockchains",
              authors:
                "T. T. A. Dinh, J. Wang, G. Chen, R. Liu, B. C. Ooi, and K.-L. Tan.",
              action: "Read Paper",
              link: "https://www.comp.nus.edu.sg/~ooibc/blockbench.pdf",
            },
          ],
        },
      ],
      action: "",
    },

    about: {
      header: "About us",
      image: about_image,
      content:
        "As populations age, managing multimorbidity—the presence of multiple chronic conditions—has become one of healthcare’s greatest challenges. More than half of older adults live with at least three chronic diseases, yet care remains fragmented, guidelines conflict, and polypharmacy increases the risk of complications. These inefficiencies result in suboptimal outcomes, unnecessary hospital visits, a disjointed care experience and poor quality of life. <br/><br/> At ChroniCare, we are reimagining multimorbidity care. Our intelligent, interoperable digital platform empowers healthcare providers and patients with clinical decision support, seamless collaboration, and patient-centered care. By harmonizing clinical guidelines, optimizing treatment plans, and enabling real-time communication, we ensure that care is coordinated, efficient, and personalized to each patient’s needs. <br/><br/> By bridging the gaps between healthcare professionals, patients, and caregivers, ChroniCare is setting a new benchmark for holistic and integrated care—enhancing efficiency, improving outcomes, and putting patients at the center of their health journey. <br/><br/> Join us in shaping the future of multimorbidity care.",
    },

    challenge: {
      header: "The Challenge",
      subheader: "Background",
      image: challenge_bg,
      content:
        "As populations age, chronic diseases are becoming more common, increasing the need for effective self-management. Digital health platforms help individuals monitor their health and reduce clinical visits. <br/><br/> However, most platforms focus on single diseases, overlooking those with multiple conditions. A more holistic integrated approach is needed for comprehensive care.",
    },

    partners: {
      header: t("PARTNERS_HEADER"),
      subheader: t("PARTNERS_SUBHEADER"),
      body: "Our Valued Partners",
      items: [
        {
          image: partners_nuhs,
          name: "NUHS",
          link: "https://www.nuhs.edu.sg/Pages/Home.aspx",
        },
        {
          image: partners_nhg,
          name: "NHG",
          link: "https://corp.nhg.com.sg/Pages/default.aspx",
        },
        {
          image: partners_singhealth,
          name: "SingHealth",
          link: "https://www.singhealth.com.sg/",
        },
        { image: partners_nus, name: "NUS", link: "https://nus.edu.sg/" },
        {
          image: partners_nusdbsys,
          name: "NUS DB System",
          link: "https://www.comp.nus.edu.sg/~dbsystem/",
        },
        { image: partners_sbip, name: "SBIP", link: "https://sbip.sg/" },
      ],
    },

    contact: {
      header: t("CONTACT_HEADER"),
      subheader: t("CONTACT_SUBHEADER"),
      content: t("CONTACT_CONTENT"),
      action: t("CONTACT_ACTION"),
    },

    contactForm: {
      header: t("CONTACT_FORM_HEADER"),
      subheader: t("CONTACT_FORM_SUBHEADER"),
      body: t("CONTACT_FORM_BODY"),
      optionPlaceholder: t("CONTACT_FORM_OPTION_PLACEHOLDER"),
      optionLabel: t("CONTACT_FORM_OPTION_LABEL"),
      options: [
        t("CONTACT_FORM_OPTION_ITEM_1"),
        t("CONTACT_FORM_OPTION_ITEM_2"),
        t("CONTACT_FORM_OPTION_ITEM_3"),
        t("CONTACT_FORM_OPTION_ITEM_4"),
      ],
      action: t("CONTACT_FORM_ACTION"),
    },

    values: {
      header: "Why ChroniCare?",
      subheader: "Our Value",
      body: "",
      items: [
        {
          image: values_1,
          header: "Empowers Patients",
          content:
            "Supports home-based self-management of multiple chronic conditions.",
        },
        {
          image: values_2,
          header: "Enhances Care Coordination",
          content:
            "Connects patients with caregivers, community clinicians, and hospital-based providers.",
        },
        {
          image: values_3,
          header: "Reduces Unscheduled Clinical Visits",
          content: "Promotes proactive care and early interventions.",
        },
      ],
      action: "",
    },

    footer: {
      socialMedia: [
        // {
        //   icon: <RiTwitterFill size="1.8em" />,
        //   label: "",
        //   link: "",
        // },
        {
          icon: <RiLinkedinBoxFill size="1.8em" />,
          label: "",
          link: "https://www.linkedin.com/",
        },
        {
          icon: <RiFacebookCircleFill size="1.8em" />,
          label: "",
          link: "https://www.facebook.com/",
        },
      ],
      address:
        "3791 JALAN BUKIT MERAH, #08-12, E-CENTRE @ REDHILL, SINGAPORE (159471)",
      email: "info@medilot.ai",
      copyright: `${t(
        "FOOTER_COPYRIGHT_HEAD"
      )} © ${new Date().getFullYear()} MediLOT. ${t("FOOTER_COPYRIGHT_END")}`,
    },
  };

  return content;
};

export default useContent;
